import { default as MuiTextField } from '@mui/material/TextField'
import ReactQuill from 'react-quill'
import { QuillEditor } from '../../../components/common/QuillEditor'
import UpsertFileButton from '../../../components/file_upload'
import FileWithContext from '../../../models/file_with_context'
import { Button, Chip, Grid } from '@material-ui/core'
import Switch from '@mui/material/Switch'
import FormControlLabel from '@mui/material/FormControlLabel'
import { EMAIL_RECIPIENTS_TYPES } from '..'

export const SendEmailForm = ({
  classes,
  recipients,
  editRecipients,
  subject,
  setSubject,
  quillValue,
  handleChangeQuill,
  attachments,
  setAttachments,
  handleSend,
  value,
  selected,
  recipientsType,
  setRecipientsType,
}) => {
  const isSendingDisabled =
    !recipients.length ||
    !value ||
    !quillValue ||
    quillValue === '<p><br></p>' ||
    !subject ||
    (recipientsType === EMAIL_RECIPIENTS_TYPES.DIRECT && selected.length > 50)

  return (
    <div className={classes.sendingForm}>
      <MuiTextField
        size="small"
        sx={{
          width: '100%',
          margin: '.5em 0 0 0',
        }}
        label="Destinataires"
        id="recipients"
        name="recipients"
        value={recipients}
        onChange={(event) => {
          editRecipients(event.target.value)
        }}
      />
      {recipientsType === EMAIL_RECIPIENTS_TYPES.DIRECT &&
        selected.length > 50 && (
          <p style={{ color: '#FF7074' }}>
            Limite maximale de 50 destinataires atteinte
          </p>
        )}

      <MuiTextField
        size="small"
        sx={{
          width: '100%',
          margin: '.5em 0 0 0',
        }}
        label="Objet"
        value={subject}
        onChange={(event) => {
          setSubject(event.target.value)
        }}
      />
      <ReactQuill
        style={{
          width: '100%',
          margin: '.5em 0 .5em',
          height: '10em',
        }}
        theme="snow"
        defaultValue={quillValue}
        value={quillValue}
        modules={QuillEditor.modules}
        formats={[
          'header',
          'bold',
          'italic',
          'underline',
          'strike',
          'blockquote',
          'list',
          'bullet',
          'indent',
          'link',
          'image',
          'clean',
        ]}
        onChange={handleChangeQuill}
      />

      <div style={{ marginTop: '50px' }}>
        {value && (
          <UpsertFileButton
            resource="file_with_context"
            documentType={FileWithContext.DOCUMENT_TYPE.COPRO}
            issuedBy={FileWithContext.ISSUED_BY.HELLO_APP}
            limitQuantity={1}
            copro_id={value?.db_id}
            validTypes={[FileWithContext.TYPE.EMAIL]}
            validCategories={[FileWithContext.CATEGORY.COMMUNICATION]}
            saveResult={(result) => {
              setAttachments((prevAttachments) => [
                ...prevAttachments,
                ...result.accepted_files,
              ])
            }}
            show_shared_select={false}
          />
        )}

        {attachments?.length > 0 &&
          attachments.map((attachment) => (
            <Chip
              key={attachment.id}
              label={attachment.purpose}
              style={{ margin: '10px 5px' }}
              onDelete={() => {
                setAttachments((prevState) =>
                  prevState.filter((att) => att.id !== attachment.id)
                )
              }}
            />
          ))}
      </div>

      <FormControlLabel
        style={{
          marginTop: '2em',
        }}
        control={
          <Switch
            checked={recipientsType === EMAIL_RECIPIENTS_TYPES.BCC}
            onChange={(event) =>
              setRecipientsType(
                event.target.checked
                  ? EMAIL_RECIPIENTS_TYPES.BCC
                  : EMAIL_RECIPIENTS_TYPES.DIRECT
              )
            }
            color="primary"
          />
        }
        label={'Envoi en CCI'}
      />

      <Button
        style={{
          marginTop: '1em',
        }}
        onClick={handleSend}
        type="submit"
        variant="outlined"
        disabled={isSendingDisabled}
      >
        Envoyer
      </Button>
    </div>
  )
}
